(function () {
  'use strict';

  // Injected by theme.liquid – only present for logged-in B2B customers
  var cfg = window.b2bConfig;
  if (!cfg || !cfg.isB2B || !cfg.email || !cfg.apiKey) return;

  var API_BASE = cfg.apiBase;
  var API_KEY  = cfg.apiKey;
  var EMAIL    = cfg.email;

  // Nachweis fuer Bestellung und Bestelluebersicht (Aufgabe #86): das Login-Token der
  // localStorage-Sitzung, sonst das von theme.liquid signierte Token der nativen
  // Shopify-Sitzung. Beide gehoeren zu EMAIL — theme.liquid setzt sie im selben Block.
  // Ohne Token wird der Kopf weggelassen, nie "Bearer undefined" gesendet.
  function orderHeaders() {
    var h = { 'Content-Type': 'application/json', 'X-Api-Key': API_KEY };
    var t = cfg.token || cfg.nativeToken;
    if (t) h['Authorization'] = 'Bearer ' + t;
    return h;
  }

  // ── Helpers ────────────────────────────────────────────────────────────────

  // Kaufmännisch auf `dec` Nachkommastellen runden. Nötig, weil toFixed() auf
  // Double-Werten ABSCHNEIDET statt zu runden: (0.075).toFixed(2) === "0.07",
  // obwohl der Abacus-Preis 0.075 kaufmännisch 0.08 ergibt (so rechnet auch
  // DraftOrderBuilder mit round($vp * $cf / $gf, 2) im Bestellpfad). toPrecision(12)
  // glättet den Binärfehler vor dem Runden → 0.075→0.08, 1.005→1.01, 0.145→0.15.
  function roundDec(n, dec) {
    if (window.SU) return window.SU.roundDec(n, dec);
    var d = (dec === undefined) ? 2 : dec;
    var x = parseFloat(n);
    if (!isFinite(x)) return x;
    var f = Math.pow(10, d);
    return Math.round(Number((x * f).toPrecision(12))) / f;
  }

  // Einheitspreis-Formatierer (3 Nachkommastellen) — eine Wahrheit in assets/unit-price.js.
  // q = Verkaufseinheit: nur ein heruntergerechneter Preis bekommt 3 Nachkommastellen.
  function suUnitPrice(chf, q) {
    if (window.SU) return window.SU.unitPrice(chf, q);
    var dec = (q && q <= 1) ? 2 : 3;
    return roundDec(chf, dec).toFixed(dec);
  }

  function formatPrice(amount) {
    var num = roundDec(amount, 2);
    return 'CHF\u00a0' + num.toFixed(2).replace('.', '.').replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  }

  function fetchPrices(skus) {
    var url = API_BASE + '/api/b2b/customer-prices?email=' + encodeURIComponent(EMAIL);
    skus.forEach(function (s) { url += '&skus[]=' + encodeURIComponent(s); });
    return fetch(url, { headers: { 'X-Api-Key': API_KEY } })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        // Handle Abacus-Ausfall signal (Leitbild §9)
        if (result.abacus_available === false) {
          showAbacusWarning(result.fallback_level);
        } else {
          hideAbacusWarning();
        }
        // Unwrap: API now returns {prices:{...}, abacus_available:bool, fallback_level:string}
        return { prices: result.prices || result, meta: result };
      });
  }

  function showAbacusWarning(level) {
    var el = document.getElementById('b2b-abacus-warning');
    if (!el) {
      el = document.createElement('div');
      el.id = 'b2b-abacus-warning';
      el.style.cssText = 'background:#fff3cd;border:1px solid #ffc107;color:#856404;padding:.7rem 1rem;border-radius:3px;font-size:1.3rem;margin:.8rem 0;';
      var target = document.querySelector('.cart-footer, .cart-footer__contents, #CartDrawer-Footer');
      if (target) target.insertBefore(el, target.firstChild);
    }
    if (level === 'none') {
      el.textContent = window.customStrings.abacusUnreachable;
    } else {
      el.textContent = 'Hinweis: Deine Firmenpreise konnten aktuell nicht geladen werden. Es werden Listenpreise angezeigt. Verbindliche Preise erhältst du nach Bestelleingang.';
    }
  }

  function hideAbacusWarning() {
    var el = document.getElementById('b2b-abacus-warning');
    if (el) el.remove();
  }

  // ── Product page ───────────────────────────────────────────────────────────

  // Returns current variant SKU from the theme's SKU block (.product__sku)
  function getCurrentSku() {
    var el = document.querySelector('.product__sku');
    if (!el) return null;
    var text = el.textContent.trim();
    // Format from theme: "SKU: K20DSI16" or just "K20DSI16"
    var parts = text.split(':');
    return (parts.length > 1 ? parts[parts.length - 1] : parts[0]).trim() || null;
  }

  function applyPriceToElements(price, scope) {
    var formatted = formatPrice(price);
    (scope || document).querySelectorAll(
      '.price-item--regular, .price-item--sale.price-item--last, .price-item--last'
    ).forEach(function (el) {
      el.textContent = formatted;
      el.dataset.b2bApplied = '1';
    });
  }

  // Wendet einen B2B-Preis auf die PDP an (Pack/Pro-Einheit-Heuristik). Idempotent:
  // liest data-su-*-Attribute (werden nicht mutiert) → mehrfacher Aufruf (Cache +
  // Revalidate) liefert dasselbe Ergebnis.
  function applyPdpPrice(price) {
    if (price === null || price === undefined) return;
    // VPE-Einzelprodukt: der B2B-Wert (FindProductPrice) ist der Pro-Einheit-Preis.
    // Auf der PDP den GESAMT-Verpackungspreis prominent halten und den Pro-Einheit-Preis
    // in die dezente Sekundärzeile schreiben (gleiche Pack/Einheit-Heuristik wie im Warenkorb).
    //
    // WICHTIG (Bugfix 2026-07-23): NUR den Hauptpreis DIESES Produkts anfassen. Früher wurde
    // `document.querySelector('.price[data-su-qty]')` genommen = das ERSTE Preis-Element der
    // Seite. Das ist oft eine Cross-Sell-/Zubehör-Karte (z. B. Erdungsklemme mit su-qty=1) und
    // steht im DOM vor dem Hauptpreis → falsches q (1 statt VPE) UND `applyPriceToElements(…, null)`
    // überschrieb dokumentweit ALLE `.price-item--regular` (inkl. Haupt-Packpreis) mit dem
    // Pro-Einheit-Wert → „CHF 4.53 / VPE" statt „CHF 45.25 / VPE". Jetzt: Scope = der Haupt-
    // Preis-Wrapper (#price-…__main bzw. data-b2b-sku = aktuelle Produkt-SKU).
    var scope = document.querySelector('[id^="price-"][id$="__main"]');
    if (!scope) {
      var sku = getCurrentSku();
      var byS = sku ? document.querySelector('.price[data-b2b-sku="' + sku + '"]') : null;
      scope = byS ? (byS.closest('[id^="price-"]') || byS) : null;
    }
    var root = scope || document;
    var pd = root.querySelector('.price[data-su-qty]')
          || (scope ? scope.querySelector('.price') : document.querySelector('.price[data-su-qty]'));
    var q  = pd ? (parseFloat(pd.getAttribute('data-su-qty') || '0') || 0) : 0;
    if (q > 1) {
      var base    = pd.getAttribute('data-su-base') || 'Stück';
      var packChf = (parseFloat(pd.getAttribute('data-su-pack') || '0') || 0) / 100;
      var pdpNorm = normalizeUnit(price, packChf, q);
      var perUnit = pdpNorm.perUnit, packPrice = pdpNorm.packPrice;
      applyPriceToElements(packPrice, root);
      root.querySelectorAll('.price__unit-secondary').forEach(function (el) {
        // Abgeleiteter Einheitspreis: shop-weit 3 Nachkommastellen (window.SU.unitPrice; das
        // Liquid-Gegenstück ist money-dec mit dec: 3).
        el.textContent = 'CHF ' + suUnitPrice(perUnit, q) + ' / ' + (window.unitLabel ? window.unitLabel(base) : base);
      });
    } else {
      applyPriceToElements(price, root);
    }
  }

  // Sticky-Bar-Variantenauswahl: <option>-Texte tragen den Brutto-Listenpreis und wurden von
  // keinem B2B-Modul angefasst (alle schreiben in .price-item*) → B2B-Kunden sahen dort den
  // Listenpreis neben ihrem Nettopreis. Optionen können keine Kind-Elemente enthalten, deshalb
  // wird der ganze Text neu gesetzt: "<Variantentitel> - <B2B-Packpreis>".
  function updateStickySelectPrices() {
    var sel = document.querySelector('select[data-b2b-select]');
    if (!sel) return;
    var opts = Array.prototype.slice.call(sel.querySelectorAll('option[data-sku]'));
    var skus = opts.map(function (o) { return o.getAttribute('data-sku'); }).filter(Boolean);
    if (!skus.length) return;
    fetchPrices(skus).then(function (result) {
      var prices = result.prices || {};
      opts.forEach(function (o) {
        var p = prices[o.getAttribute('data-sku')];
        if (p === null || p === undefined) return;   // kein B2B-Preis → Listenpreis stehen lassen
        var q       = parseFloat(o.getAttribute('data-su-qty') || '0') || 0;
        var packChf = (parseInt(o.getAttribute('data-price'), 10) || 0) / 100;
        var pack    = normalizeUnit(p, packChf, q).packPrice;
        o.textContent = (o.getAttribute('data-vtitle') || o.textContent) + ' - ' + formatPrice(pack);
      });
    }).catch(function (e) { console.warn('[B2B] sticky select price fetch failed:', e); });
  }

  var _lastSku = null;
  // Skeleton-/Shimmer-Zustand auf dem PDP-Preis: verhindert, dass B2B-Kunden kurz
  // den Listenpreis als final sehen, während der Individualpreis noch lädt.
  // Idempotent; greift nur ohne Cache-Treffer, Fail-safe beendet ihn in jedem Fall.
  // Merkt sich die EXAKT getoggelten Knoten (statt den Selektor beim Entfernen neu zu
  // berechnen) → kein hängender Skeleton, falls sich data-b2b-sku zwischenzeitlich ändert.
  var _pdpPendingEls = [];
  function setPdpPending(sku, on) {
    if (on) {
      // Vorherige (evtl. bei schnellem Variantenwechsel) zuerst lösen → keine Waisen.
      _pdpPendingEls.forEach(function (el) { el.classList.remove('b2b-price-pending'); });
      // NUR den Hauptpreis DIESES Produkts treffen, nicht Related-Product-Karten:
      // das Hauptpreis-.price trägt data-b2b-sku == Produkt-SKU (Karten haben andere SKUs).
      // Fallback: der Preis-Wrapper mit id="price-…__main" (+ dessen Sticky-Dublette).
      var els = sku ? document.querySelectorAll('.price[data-b2b-sku="' + sku + '"]') : [];
      if (!els.length) els = document.querySelectorAll('[id^="price-"][id$="__main"] .price');
      _pdpPendingEls = Array.prototype.slice.call(els);
      _pdpPendingEls.forEach(function (el) { el.classList.add('b2b-price-pending'); });
    } else {
      _pdpPendingEls.forEach(function (el) { el.classList.remove('b2b-price-pending'); });
      _pdpPendingEls = [];
    }
  }
  function updateProductPagePrice() {
    // Variantenmatrix-Produkte: den Top-"Ab"-Preis besitzt variant-matrix.js
    // (Minimum über alle B2B-Variantenpreise). Hier NICHT den Einzelpreis der
    // ersten Variante über den "Ab"-Preis schreiben.
    if (document.querySelector('variant-matrix')) return;
    var sku = getCurrentSku();
    if (!sku || sku === _lastSku) return;
    _lastSku = sku;

    // SWR Schritt 1: persistenten Cache-Wert SOFORT anzeigen (kein Flash).
    // Ohne Cache-Treffer: Skeleton statt Listenpreis, bis der echte Preis geladen ist.
    var hasCache = false;
    if (window.B2BPriceCache) {
      var hit = window.B2BPriceCache.get(sku);
      if (hit) { applyPdpPrice(hit.price); hasCache = true; }
    }
    if (!hasCache) setPdpPending(sku, true);

    // SWR Schritt 2: immer live revalidieren; Skeleton in JEDEM Ausgang beenden.
    var failSafe = setTimeout(function () { setPdpPending(sku, false); }, 4000);
    fetchPrices([sku]).then(function (result) {
      clearTimeout(failSafe);
      var price = result.prices[sku];
      applyPdpPrice(price);
      setPdpPending(sku, false);
      if (window.B2BPriceCache && price !== null && price !== undefined) {
        window.B2BPriceCache.set(sku, price, result.meta && result.meta.fallback_level);
      }
    }).catch(function (e) {
      clearTimeout(failSafe);
      setPdpPending(sku, false);
      console.warn('[B2B] price fetch failed:', e);
    });
  }

  // Rechnet den Gratis-Versand-Balken im Cart-Drawer auf den tatsächlichen B2B-Gesamtbetrag
  // (Individualpreise) um. Der Balken wird serverseitig aus cart.total_price (Listenpreis)
  // gerendert; hier korrigieren wir Fortschritt, Icon-Position und Resttext. Idempotent.
  // Erster Anstrich des Balkens durch dieses Modul (pro Rendering) — s. Kommentar unten.
  var _fsBarPainted = false;
  // Letzter von diesem Modul gesetzter B2B-Warenwert (Rappen), null = noch keiner bekannt.
  // Dient als Startpunkt nach einem Re-Render, damit der Balken nicht auf den Liquid-Stand
  // (Gast-Schwelle → fast immer 100 %) hochschnellt und erst danach zurueckfaellt.
  var _fsLastCents = null;

  function updateFreeShippingBar(b2bTotalCents) {
    var msg = document.querySelector('.drawer_offering_bar .shipping-savings-message');
    if (!msg) return;
    // ⚠️ Schwelle ist KUNDENTYP-abhaengig: B2B-Kunden werden ab CHF 800 als „Versand kostenlos"
    // gefuehrt, Gaeste ab CHF 75 (Wegfall des Kleinmengenzuschlags). Das Liquid-Attribut traegt
    // den GAST-Wert; fuer B2B liefert window.SP die eigene Schwelle. Das DOM-Attribut wird dabei
    // bewusst NICHT ueberschrieben — die Funktion laeuft bei jeder Cart-Mutation erneut und
    // waere sonst nicht idempotent.
    var threshold = parseInt(msg.getAttribute('data-fs-threshold') || '0', 10);
    if (window.SP && typeof window.SP.barThreshold === 'function') {
      var spT = parseInt(window.SP.barThreshold(), 10);
      if (isFinite(spT) && spT > 0) threshold = spT;
    }
    if (!threshold || threshold <= 0) return; // keine Schwelle konfiguriert → unverändert lassen

    var leftCents = threshold - b2bTotalCents;
    var range = (b2bTotalCents * 100) / threshold;
    if (range > 100) range = 100;
    if (range < 0) range = 0;

    // Fortschrittsbalken + Icon.
    var bar = msg.closest('.drawer_offering_bar') || document;
    var fill = bar.querySelector('.free_inner_slider');
    var icon0 = bar.querySelector('.free_inner_slider_icon');
    // ⚠️ Erster Lauf nach dem Rendern OHNE Animation: Liquid zeichnet den Balken gegen die
    // GAST-Schwelle (CHF 75) — fuer einen B2B-Kunden steht er damit fast immer auf 100 %, und
    // die Korrektur auf die B2B-Schwelle (CHF 800) lief als sichtbare Rueckwaerts-Animation
    // ueber die halbe Leiste. Einmalig die Transition aussetzen, danach wieder animieren.
    if (!_fsBarPainted) {
      if (fill) fill.style.transition = 'none';
      if (icon0) icon0.style.transition = 'none';
    }
    if (fill) fill.style.width = range + '%';
    var icon = bar.querySelector('.free_inner_slider_icon');
    if (icon) {
      // Icon MITTIG auf das Fortschrittsende, in der Spur gehalten. Die frühere Fallunter-
      // scheidung (2px / X% / calc(100% - 24px)) versetzte den Bezugspunkt je nach Bereich:
      // in der Mitte sass die linke Kante auf dem Fortschritt, an den Enden die Mitte — das
      // Icon sprang beim Übergang. clamp() macht daraus eine durchgehende Bewegung.
      icon.style.left = 'clamp(0px, calc(' + range + '% - 13px), calc(100% - 26px))';
    }
    if (!_fsBarPainted) {
      // Reflow erzwingen, damit der gesetzte Wert ohne Animation uebernommen wird, dann die
      // CSS-Transition wieder freigeben (Folgeaenderungen sollen weich laufen).
      if (fill) void fill.offsetWidth;
      if (fill) fill.style.transition = '';
      if (icon0) icon0.style.transition = '';
      _fsBarPainted = true;
    }

    // Resttext ("noch CHF X bis Gratisversand") vs. Erreicht-Meldung.
    var need = msg.querySelector('.fs-need');
    var done = msg.querySelector('.fs-done');
    var amt  = msg.querySelector('.fs-amount');
    if (leftCents > 0) {
      if (amt) amt.textContent = formatPrice(leftCents / 100);
      if (need) need.style.display = '';
      if (done) done.style.display = 'none';
    } else {
      if (need) need.style.display = 'none';
      if (done) done.style.display = '';
    }

    _fsLastCents = b2bTotalCents;
  }

  // Variant-ID einer Warenkorbzeile robust bestimmen. Je nach Template steht sie an
  // unterschiedlichen Attributen:
  //   [data-variant-id]          → Warenkorb-Drawer (cart-drawer.liquid)
  //   [data-quantity-variant-id] → Warenkorb-SEITE (main-cart-items.liquid, Mengen-Input)
  //   input[name="id"]           → Add-to-Cart-Formulare (value = Variant-ID)
  //   row.dataset.variantId      → Fallback am Zeilen-Element
  // Bug (bis 20.07.2026): der alte Selektor kannte data-quantity-variant-id nicht → auf der
  // Warenkorb-SEITE war vid=0, jede Zeile wurde übersprungen und der B2B-Individualpreis nie
  // angewandt (Kunde sah den Listenpreis). input.value liefert beim Mengen-Input die MENGE
  // statt der ID → .value wird nur für name="id" genutzt.
  function rowVariantId(row) {
    if (window.SU) return window.SU.variantIdOf(row);
    var idEl = row.querySelector('[data-variant-id], [data-quantity-variant-id], input[name="id"]');
    var vid = 0;
    if (idEl) {
      vid = parseInt(
        idEl.dataset.variantId
        || idEl.dataset.quantityVariantId
        || (idEl.getAttribute('name') === 'id' ? idEl.value : 0)
        || 0,
        10
      );
    }
    if (!vid) vid = parseInt(row.dataset.variantId || 0, 10);
    return vid || 0;
  }

  // Der Abacus-/B2B-Wert ist je Artikel ENTWEDER der Packpreis ODER bereits der Pro-Einheit-Preis
  // (FindProductPrice-Einheit ist artikelabhängig, kein Signal in der Antwort). Gegen den
  // Gast-Packpreis entscheiden → konsistentes (Pack, Pro-Einheit)-Paar.
  function normalizeUnit(rawChf, guestPackChf, q, opts) {
    if (window.SU) return window.SU.normalize(rawChf, guestPackChf, q, opts);
    var P = parseFloat(rawChf);
    if (opts && opts.isSet) return { perUnit: P, packPrice: P };
    if (!(q > 1)) return { perUnit: P, packPrice: P };
    // Fallback-Spiegel von SU.normalize (unit-price.js) — beide Kriterien, siehe dort.
    if (guestPackChf > 0 && (P > guestPackChf / Math.sqrt(q) || P * q > guestPackChf * 1.25)) {
      return { perUnit: P / q, packPrice: P };      // B2B-Wert war Packpreis
    }
    return { perUnit: P, packPrice: P * q };        // B2B-Wert war Pro-Einheit-Preis
  }

  // ── Cart prices ────────────────────────────────────────────────────────────

  // Skeleton auf allen Warenkorb-Positionspreisen, solange die B2B-Preise laden
  // (der Warenkorb macht kein Cache-First → sonst blitzt kurz der Listenpreis auf).
  function setCartPending(on) {
    document.querySelectorAll('.cart-item, .cart-drawer__item').forEach(function (row) {
      row.querySelectorAll(
        '.cart-item__final-price, .cart-item__regular-price, .cart-item__unitprice, .cart-item__totals .price'
      ).forEach(function (el) { el.classList.toggle('b2b-price-pending', !!on); });
    });
  }

  // Lauf-Zähler gegen out-of-order Antworten. Ein einzelnes Add-to-Cart startet HEUTE zwei
  // gleichzeitige Durchläufe: cart-drawer.js::renderContents ruft window.B2BRefreshCart() auf
  // UND product-form.js publiziert PUB_SUB_EVENTS.cartUpdate (→ Subscription am Dateiende).
  // Löst die ältere /cart.json-Antwort zuletzt auf, schreibt sie den VERALTETEN Total zurück –
  // im Drawer sichtbar als „Geschätzte Gesamtkosten aktualisieren sich nicht".
  var _cartRun = 0;

  function updateCartPrices() {
    // Der Drawer/​die Warenkorbseite rendern bei jeder Mutation NEU und bringen damit den
    // Liquid-Stand zurueck: der ist gegen die GAST-Schwelle (CHF 75) gerechnet und steht fuer
    // einen B2B-Kunden praktisch immer auf 100 %. Sichtbar war das als Sprung nach RECHTS auf
    // voll, gefolgt von der Korrektur zurueck — beim Hinzufuegen eines Artikels jedes Mal.
    // Deshalb hier SOFORT (synchron, vor dem naechsten Paint) auf den letzten bekannten
    // B2B-Stand setzen — bzw. auf 0, solange keiner bekannt ist. Die echte Zahl kommt
    // Millisekunden spaeter und wandert von dort weich weiter, statt zurueckzuspringen.
    _fsBarPainted = false;
    updateFreeShippingBar(_fsLastCents == null ? 0 : _fsLastCents);
    var myRun = ++_cartRun;
    var isStale = function () { return myRun !== _cartRun; };

    setCartPending(true);
    var _failSafe = setTimeout(function () { setCartPending(false); }, 5000);
    var _doneCart = function () { clearTimeout(_failSafe); setCartPending(false); };
    // Veralteter Lauf: nur den eigenen Fail-safe abräumen. Das Skeleton NICHT beenden — sonst
    // blitzt der Listenpreis auf, während der neuere Lauf noch lädt.
    var _abandon  = function () { clearTimeout(_failSafe); };
    fetch('/cart.json')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (isStale()) { _abandon(); return; }
        var items = cart.items || [];
        var skus  = items.map(function (i) { return i.sku; }).filter(Boolean);
        if (!skus.length) {
          // ⚠️ LEERER Warenkorb trotzdem den Gratis-Versand-Balken setzen. Ohne diesen Aufruf
          // blieb der aus Liquid gerenderte GAST-Wert stehen (CHF 75) — ein eingeloggter
          // B2B-Kunde las „Ab CHF 75.00 erhälst du kostenlosen Versand", obwohl für ihn die
          // B2B-Schwelle (CHF 800, window.SP.b2bFreeCents) gilt. Total = 0, weil nichts im Korb
          // liegt; updateFreeShippingBar() zieht die Schwelle selbst aus window.SP.
          updateFreeShippingBar(0);
          _doneCart();
          return;
        }

        fetchPrices(skus).then(function (result) {
          if (isStale()) { _abandon(); return; }
          var prices = result.prices;
          // Die im Warenkorb ANGEZEIGTEN B2B-Preise cachen → der §12-Preischeck beim Checkout
          // vergleicht dagegen (gleiche Einheit, netto/Basis) und schlägt nur bei ECHTER Änderung
          // an — nicht mehr Liste vs. Individualpreis.
          if (window.B2BPriceCache && window.B2BPriceCache.setMany) {
            window.B2BPriceCache.setMany(prices, result.meta && result.meta.fallback_level);
          }
          // Build variantId → b2bPrice map. packCents = Gast-Packpreis (Shopify-Stückpreis,
          // = korrekte VE-Basis); guestLineCents = bisheriges Gast-Zeilentotal.
          var byVariant = {};
          items.forEach(function (item) {
            var p = prices[item.sku];
            if (p !== null && p !== undefined) {
              byVariant[item.variant_id] = {
                price: p,
                qty: item.quantity,
                packCents: item.price || 0,
                guestLineCents: (item.final_line_price != null ? item.final_line_price : item.line_price) || 0,
              };
            }
          });

          // Verkaufseinheit (VPE) je Variante EINMAL aus dem DOM lesen.
          // ⚠️ Auf /cart rendert layout/theme.liquid den Cart-Drawer mit
          // (settings.cart_type == 'drawer', ohne Template-Guard), und dessen Zeilen tragen
          // dieselbe Klasse .cart-item wie die Warenkorbseite → jede Position liegt DOPPELT
          // im DOM. Deshalb wird hier nach Variant-ID dedupliziert.
          var vpeByVariant = {};
          document.querySelectorAll('.cart-item, .cart-drawer__item').forEach(function (row) {
            var rvid = rowVariantId(row);
            if (!rvid || vpeByVariant[rvid]) return;
            var upEl = row.querySelector('.cart-item__unitprice');
            vpeByVariant[rvid] = {
              q:    upEl ? (parseFloat(upEl.getAttribute('data-suq') || '0') || 0) : 0,
              base: upEl ? (upEl.getAttribute('data-subase') || 'Stück') : 'Stück'
            };
          });

          // Pack-/Pro-Einheit-Paar je Variante bilden — eine Wahrheit für Anzeige UND Summe.
          var normByVariant = {};
          Object.keys(byVariant).forEach(function (k) {
            var e = byVariant[k];
            var v = vpeByVariant[k] || { q: 0, base: 'Stück' };
            normByVariant[k] = normalizeUnit(e.price, (e.packCents || 0) / 100, v.q);
          });

          // GA4-Hook: die eben berechneten, ANGEZEIGTEN Packpreise weiterreichen.
          // ⭐ Bewusst hier und nicht im Cache-Lookup: das ist exakt die Zahl, die der
          //    Kunde sieht — inklusive Einheiten-Normalisierung. Ein Nachbauen der
          //    Umrechnung in gtm-ecommerce.js waere eine zweite Wahrheit und wuerde
          //    frueher oder spaeter abweichen. Rein additiv, in try/catch.
          try {
            if (window.GTMEC && window.GTMEC.onCartPrices) {
              var _gaSkuByVariant = {};
              items.forEach(function (it) { _gaSkuByVariant[it.variant_id] = it.sku; });
              window.GTMEC.onCartPrices(normByVariant, _gaSkuByVariant, cart);
            }
          } catch (e) {}

          // ⚠️ Gesamttotal AUSSCHLIESSLICH aus den cart.json-Daten bilden, NIEMALS im DOM-Loop
          // akkumulieren. Der Drawer wird auf /cart mitgerendert (s. o.) → jede Differenz würde
          // doppelt gezählt: grand = T + 2·(B − T) = 2·B − T. Bei ~40 % Rabatt plus 8,1 % MwSt
          // heraus ist B ≈ T/2, und die „Geschätzten Gesamtkosten" landeten bei 0.00.
          var grand = (cart.total_price || 0) / 100;
          Object.keys(byVariant).forEach(function (k) {
            var e = byVariant[k];
            grand += (normByVariant[k].packPrice * e.qty) - ((e.guestLineCents || 0) / 100);
          });

          document.querySelectorAll('.cart-item, .cart-drawer__item').forEach(function (row) {
            var vid = rowVariantId(row);
            if (!vid || !byVariant[vid]) return;

            var qty = byVariant[vid].qty;
            var n   = normByVariant[vid];
            var v   = vpeByVariant[vid] || { q: 0, base: 'Stück' };

            // Stückpreis (pro Bestelleinheit = pro VE) = Packpreis.
            row.querySelectorAll(
              '.cart-item__final-price, .cart-item__regular-price, .price-item'
            ).forEach(function (el) {
              el.textContent = formatPrice(n.packPrice);
            });

            // Zeilentotal = Packpreis × Menge — in ALLE .cart-item__totals-Zellen.
            // ⚠️ main-cart-items.liquid rendert ZWEI davon (eine nur für den mittleren
            // Breakpoint via small-hide large-up-hide, eine für Desktop). Das frühere
            // querySelector() traf nur die unsichtbare erste → die sichtbare Spalte
            // „Gesamtsumme" behielt den Listenpreis.
            // Ist die Position rabattiert, ist das erste .price der durchgestrichene
            // Altpreis (<s class="cart-item__old-price price">) → gezielt ausschliessen.
            row.querySelectorAll('.cart-item__totals').forEach(function (cell) {
              var el = cell.querySelector('.price:not(.cart-item__old-price)');
              if (el) el.textContent = formatPrice(n.packPrice * qty);
            });

            // Pro-Einheit-Zeile (z. B. „CHF 1.0500 / m") auf B2B-Pro-Einheit aktualisieren.
            var up = row.querySelector('.cart-item__unitprice');
            if (up && v.q > 0) {
              // Bis 12.08.2026: 4 Stellen bei Meterware, 2 sonst. Jetzt überall 3 — dieselbe
              // Zeile rendert serverseitig snippets/cart-vpe-info.liquid (money-dec dec: 3).
              up.textContent = 'CHF ' + suUnitPrice(n.perUnit, v.q) + ' / ' + (window.unitLabel ? window.unitLabel(v.base) : v.base);
            }
          });

          // Warenkorb-Gesamtpreis setzen: Footer/Drawer (.totals__total-value) UND der
          // Betrag neben dem Warenkorb-Icon im Header (data-b2b-cart-total, gesetzt in
          // sections/header.liquid + sections/cart-icon-bubble.liquid). Letzterer zeigte bis
          // 2026-08-11 dauerhaft den Brutto-Listenpreis, weil ihn kein B2B-Modul kannte.
          document.querySelectorAll('.totals__total-value, [data-b2b-cart-total]').forEach(function (el) {
            el.textContent = formatPrice(grand);
          });

          // Gratis-Versand-Balken auf den B2B-Gesamtbetrag umrechnen (statt Listenpreis-Total).
          var b2bTotalCents = Math.round(grand * 100);
          updateFreeShippingBar(b2bTotalCents);

          // B2B-Gesamtbetrag für andere Module bereitstellen (z. B. checkout-gate.js:
          // Gratis-Versand-Schwelle muss auf den Individualpreis-Total statt cart.total_price).
          window.B2BCart = {
            totalCents: b2bTotalCents,
            guestCents: cart.total_price || 0,
            ready: true,
          };
          document.dispatchEvent(new CustomEvent('b2b:cart-total', { detail: window.B2BCart }));
          _doneCart();
        }).catch(function (e) {
          _doneCart();
          // ⚠️ Ohne Preise ist der Listenpreis-Total die einzige Wahrheit, die wir haben. Ohne
          // diesen Fallback bliebe der Balken auf dem oben gesetzten Vorstand (bzw. 0 %) stehen
          // und zeigte einem B2B-Kunden dauerhaft einen zu niedrigen Fortschritt.
          updateFreeShippingBar(cart.total_price || 0);
          console.warn('[B2B] cart price fetch failed:', e);
        });
      }).catch(function (e) {
        _doneCart();
        console.warn('[B2B] cart fetch failed:', e);
      });
  }

  // ── B2B Checkout via Draft Order ──────────────────────────────────────────

  function escHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function setCheckoutBtns(disabled, label) {
    Array.from(document.querySelectorAll('#CartDrawer-Checkout, button[name="checkout"]')).forEach(function (b) {
      if (disabled) {
        b.dataset.origText = b.dataset.origText || b.textContent.trim();
        b.disabled = true;
        b.textContent = label || 'Bitte warten\u2026';
      } else {
        b.disabled = false;
        b.textContent = b.dataset.origText || 'Zur Kasse';
      }
    });
  }

  function showCheckoutError(msg) {
    var el = document.getElementById('b2b-checkout-error');
    if (!el) {
      el = document.createElement('div');
      el.id = 'b2b-checkout-error';
      el.style.cssText = 'padding:.7rem 1rem;border-radius:3px;font-size:1.3rem;margin:.8rem 0;';
      var target = document.querySelector('.cart-footer, .cart-footer__contents, #CartDrawer-Footer');
      if (target) target.insertBefore(el, target.firstChild);
    }
    el.style.background = '#fee2e2';
    el.style.border = '1px solid #fca5a5';
    el.style.color = '#991b1b';
    el.textContent = msg;
  }

  // Leitbild §12: Show changed prices in modal — user must actively confirm new prices
  function showPriceConfirmOverlay(changed, onConfirm) {
    var existing = document.getElementById('b2b-price-confirm-overlay');
    if (existing) existing.remove();

    var rows = changed.map(function (item) {
      return '<tr>'
        + '<td style="padding:.4rem .6rem;border-bottom:1px solid #f3f4f6">' + escHtml(item.sku) + '</td>'
        + '<td style="padding:.4rem .6rem;border-bottom:1px solid #f3f4f6;text-decoration:line-through;color:#9ca3af">' + formatPrice(item.oldPrice) + '</td>'
        + '<td style="padding:.4rem .6rem;border-bottom:1px solid #f3f4f6;font-weight:bold;color:#b91c1c">' + formatPrice(item.newPrice) + '</td>'
        + '</tr>';
    }).join('');

    var overlay = document.createElement('div');
    overlay.id = 'b2b-price-confirm-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem';
    overlay.innerHTML =
      '<div style="background:#fff;border-radius:6px;max-width:500px;width:100%;padding:1.6rem;box-shadow:0 8px 32px rgba(0,0,0,.25)">'
      + '<h2 style="margin:0 0 .8rem;font-size:1.7rem;font-weight:700">' + window.customStrings.lgPriceChangeH2 + '</h2>'
      + '<p style="margin:0 0 1rem;font-size:1.3rem;color:#4b5563">' + window.customStrings.lgPriceChangeP + '</p>'
      + '<table style="width:100%;border-collapse:collapse;margin-bottom:1.2rem;font-size:1.3rem">'
      + '<thead><tr>'
      + '<th style="text-align:left;padding:.4rem .6rem;border-bottom:2px solid #e5e7eb">' + window.customStrings.pcArticleNr + '</th>'
      + '<th style="text-align:left;padding:.4rem .6rem;border-bottom:2px solid #e5e7eb">' + window.customStrings.pcPrevPrice + '</th>'
      + '<th style="text-align:left;padding:.4rem .6rem;border-bottom:2px solid #e5e7eb">' + window.customStrings.pcCurrentPrice + '</th>'
      + '</tr></thead>'
      + '<tbody>' + rows + '</tbody>'
      + '</table>'
      + '<div style="display:flex;gap:.8rem;flex-wrap:wrap">'
      + '<button id="b2b-price-confirm-ok" style="flex:1;min-width:160px;background:#1a1a1a;color:#fff;border:none;padding:.7rem 1rem;border-radius:4px;font-size:1.3rem;cursor:pointer">' + window.customStrings.lgPriceConfirmBtn + '</button>'
      + '<button id="b2b-price-confirm-cancel" style="flex:0 0 auto;background:#fff;color:#374151;border:1px solid #d1d5db;padding:.7rem 1rem;border-radius:4px;font-size:1.3rem;cursor:pointer">' + window.customStrings.cancelJs + '</button>'
      + '</div>'
      + '</div>';

    document.body.appendChild(overlay);
    document.getElementById('b2b-price-confirm-ok').addEventListener('click', function () {
      overlay.remove();
      onConfirm();
    });
    document.getElementById('b2b-price-confirm-cancel').addEventListener('click', function () {
      overlay.remove();
      setCheckoutBtns(false);
    });
  }

  // Verbindliche Bestellübersicht für "Kauf auf Rechnung": holt die autoritative Übersicht vom
  // read-only Preview-Endpoint und zeigt sie als Overlay. Erst die Bestätigung dort bestellt.
  function showInvoiceReviewOverlay(cart, items, noteAttributes) {
    var bySku = {};
    (cart.items || []).forEach(function (i) { bySku[i.sku] = i; });

    var payload = { customer_email: EMAIL, items: items.map(function (i) { return { sku: i.sku, quantity: i.quantity }; }) };
    if (noteAttributes && noteAttributes.length) payload.note_attributes = noteAttributes;
    // Hoechster „max. Versandpreis" der Warenkorbzeilen → Server antwortet mit shipping_max,
    // den der Disclaimer nennt. ⚠️ Gleiche Ergaenzung wie in checkout-gate.js
    // (cgBuildOrderPayload) — fehlt sie hier, zeigt die NATIVE Session keinen Maximalbetrag,
    // die Gate-Session aber schon. Genau so laufen die beiden Uebersichten auseinander.
    if (window.SP && typeof window.SP.maxShipFromDom === 'function') {
      var mxShip = window.SP.maxShipFromDom();
      if (mxShip > 0) payload.max_ship = mxShip;
    }

    fetch(API_BASE + '/api/b2b/preview-invoice-order', {
      method: 'POST',
      headers: orderHeaders(),
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        setCheckoutBtns(false);
        if (!res.ok || !res.data || res.data.status !== 'preview') {
          showCheckoutError((res.data && res.data.error) || window.customStrings.reviewLoadFailed);
          return;
        }
        // Fuer das purchase-Event festhalten: der create-Endpoint liefert nur die
        // Bestellnummer, Positionen und Summen stehen ausschliesslich im Preview.
        _lastPreview = res.data;
        _lastTitles  = {};
        Object.keys(bySku).forEach(function (sku) {
          var i = bySku[sku];
          _lastTitles[sku] = (i && (i.product_title || i.title)) || '';
        });

        // GA4 begin_checkout — der Rechnungspfad erreicht Shopifys checkout_started nie.
        if (window.GTMEC) window.GTMEC.beginCheckout(_lastPreview, _lastTitles);

        renderInvoiceReviewOverlay(res.data, bySku, function () {
          proceedToCheckout(items, 'invoice', noteAttributes);
        });
      })
      .catch(function () {
        setCheckoutBtns(false);
        showCheckoutError('Verbindungsfehler. Bitte erneut versuchen.');
      });
  }

  // Bestellübersicht „Kauf auf Rechnung". Markup + Klassen, Optik in
  // assets/component-invoice-review.css. Bis 2026-08-12 war das eine dreispaltige Tabelle
  // mit Inline-Styles und ohne Produktbild; Verkaufseinheit, Gesamtmenge und Pro-Einheit-Preis
  // liefen als grauer Fliesstext in einer Zeile zusammen. Jetzt hat jede Angabe ein eigenes,
  // beschriftetes Feld: Produkt (Bild/Titel/Variante), VE, Anzahl VE, Gesamtmenge, Preis je VE
  // und Positionstotal.
  // ⚠️ An der RECHNERISCHEN Logik ändert sich nichts: Zwischensumme und Gesamt kommen weiterhin
  // autoritativ vom Server (preview.subtotal/.total), packPrice bleibt ln.unit_price.

  // Breite der Betragsspalte an die längste Zahl DIESER Bestellung anpassen: alle .ir-num
  // messen und die grösste Breite als --ir-num-w setzen. So stehen die „CHF" untereinander,
  // ohne dass bei kleinen Bestellungen eine feste (zu breite) Spalte klafft.
  // ⚠️ Muss NACH dem Einhängen ins DOM laufen (braucht Layout) und misst mit min-width 0,
  // sonst würde der vorherige Wert das Ergebnis zementieren.
  // ⚠️ Die Zeilen sind unterschiedlich gross gesetzt (Positionspreis, Zwischensumme, Gesamt) —
  // deshalb wird gemessen und nicht aus der Zeichenzahl gerechnet.
  function alignMoney(root) {
    if (!root) return;
    var nums = root.querySelectorAll('.ir-num');
    if (!nums.length) return;
    root.style.setProperty('--ir-num-w', '0px');
    var max = 0;
    Array.prototype.forEach.call(nums, function (n) {
      var w = n.getBoundingClientRect().width;
      if (w > max) max = w;
    });
    root.style.setProperty('--ir-num-w', Math.ceil(max) + 'px');
  }

  function renderInvoiceReviewOverlay(preview, bySku, onConfirm) {
    var existing = document.getElementById('b2b-invoice-review-overlay');
    if (existing) existing.remove();

    var CS = window.customStrings || {};

    // Verkaufseinheit (VPE) je Variante aus den Warenkorb-Zeilen lesen — gleiche Quelle/Heuristik wie
    // updateCartPrices, damit die Übersicht den VPE-Preis (Packpreis) statt des Einheitspreises zeigt.
    var vpeMap = {};
    document.querySelectorAll('.cart-item, .cart-drawer__item').forEach(function (row) {
      // ⚠️ Bugfix 2026-08-11: siehe rowVariantId() — der alte Selektor kannte
      // data-quantity-variant-id nicht und lief auf der Warenkorb-SEITE ins Leere.
      var vid = rowVariantId(row);
      if (!vid) return;
      var up = row.querySelector('.cart-item__unitprice');
      // VE-Klartext („60 Meter") aus der Warenkorbzeile; steht dort seit dem 12.08. in einem
      // eigenen Element. Fällt auf „<q> <Einheit>" zurück, wenn die Zeile fehlt (z. B. Drawer
      // noch nicht gerendert) — dann ist die Angabe hergeleitet, aber nie falsch.
      var veEl = row.querySelector('.cart-item__ve');
      vpeMap[vid] = {
        q:     up ? (parseFloat(up.getAttribute('data-suq') || '0') || 0) : 0,
        base:  up ? (up.getAttribute('data-subase') || 'Stück') : 'Stück',
        label: veEl ? veEl.textContent.replace(/^\s*VE\s*:\s*/i, '').trim() : ''
      };
    });

    // Versandart nur für die ANZEIGE übersetzen (window.shipLabel, i18n-fallback.js) — der
    // Rohtitel bleibt im Bestell-Payload und in der Draft Order.
    function shipTitle(t) {
      return window.shipLabel ? window.shipLabel(t) : t;
    }

    // Wie im Checkout-Gate: „Versand (Standardversand)" nicht doppelt schreiben.
    function shipRowLabel(shown) {
      var lbl = CS.shipping || 'Versand';
      var a = String(shown || '').toLowerCase();
      if (!a) return lbl;
      return a.indexOf(String(lbl).toLowerCase()) > -1 ? shown : (lbl + ' (' + shown + ')');
    }

    function unitLabelOf(base) {
      if (window.SU) return window.SU.qtyUnitLabel(base);
      return (window.unitLabel ? window.unitLabel(base) : base) || '';
    }

    // ⚠️ Strings aus window.customStrings sind bereits HTML-sicher — der Liquid-`t`-Filter
    // escaped sie beim Rendern (FR „l'article" → „l&#39;article"). Ein zweites escHtml() macht
    // daraus sichtbaren Zeichensalat. Deshalb: Labels roh, nur Daten aus Shopify/DOM escapen.

    // Einheitswort für die Gesamtmenge aus der VE-Bezeichnung ableiten: steht dort „60 Meter",
    // soll auch die Gesamtmenge „180 Meter" heissen und nicht „180 m" — Kunden lesen sonst zwei
    // Einheiten für dieselbe Sache. Genommen wird nur ein EINZELNES Wort ohne Ziffern
    // („60 Meter" → „Meter", „500 pièces" → „pièces"); bei zusammengesetzten Angaben
    // („1 Rolle à 100 m") bleibt es beim SI-Kürzel aus window.SU.
    function qtyUnitWord(veLabel, base) {
      var rest = String(veLabel || '').replace(/^\s*[\d'.,]+\s*/, '').trim();
      if (rest && rest.length <= 14 && !/[\d]/.test(rest) && rest.indexOf(' ') === -1) return rest;
      return unitLabelOf(base);
    }

    // „Preis je Meter" / „Preis je Stück" — Einheitswort aus derselben Ableitung wie die
    // Gesamtmenge, damit in einer Zeile nicht „Meter" und in der nächsten „m" steht.
    // ⚠️ Für den PREIS die Einheit im SINGULAR: die VE-Bezeichnung liefert den Plural
    // („60 mètres") — „Prix par mètres" wäre falsches Französisch. window.unitLabel kennt die
    // Singularformen; 'm' wird vorher auf 'Meter' gehoben, damit auf Deutsch „Preis je Meter"
    // steht und nicht „Preis je m".
    function unitPriceLabel(veLabel, base) {
      var tpl  = CS.irPricePerUnit || 'Preis je __U__';
      var long = (base === 'm' || base === 'Meter') ? 'Meter' : base;
      var word = window.unitLabel ? window.unitLabel(long) : qtyUnitWord(veLabel, base);
      return tpl.replace('__U__', word);
    }

    // Einheitspreise: shop-weit 3 Nachkommastellen (window.SU). Fallback ohne SU: 3 Stellen roh.
    function unitPriceText(chf, q) {
      return window.SU ? window.SU.unitPrice(chf, q) : (parseFloat(chf) || 0).toFixed(3);
    }

    function fact(label, valueHtml, extraClass) {
      return '<div class="ir-fact' + (extraClass ? ' ' + extraClass : '') + '">'
        + '<dt>' + label + '</dt>'
        + '<dd>' + valueHtml + '</dd>'
        + '</div>';
    }

    var subtotal = 0;
    var rows = (preview.lines || []).map(function (ln) {
      var ci = bySku[ln.sku] || {};
      // ⚠️ ln.unit_price ist BEREITS der Packpreis pro Verkaufseinheit (DraftOrderBuilder:
      // variant.price × Kunden-Netto/Gast-Netto, einheiten- und mengenunabhängig). Bis
      // 2026-08-11 lief hier nochmals die √q-Heuristik darüber und zeigte bei fehlender
      // Warenkorbreferenz das q-fache.
      var packPrice = (ln.unit_price !== null && ln.unit_price !== undefined)
        ? parseFloat(ln.unit_price)
        : ((ci.price || 0) / 100);
      var vpe  = vpeMap[ln.variant_id] || { q: 0, base: 'Stück', label: '' };
      var q    = vpe.q;
      var isVe = q > 1;

      var lt = packPrice * ln.quantity;
      subtotal += lt;

      var title = ci.product_title || ci.title || ln.sku || ((CS.articleFallback || 'Artikel') + ' ' + ln.variant_id);
      var vt    = (ci.variant_title && ci.variant_title !== 'Default Title') ? ci.variant_title : '';
      var img   = (ci.featured_image && ci.featured_image.url) || ci.image || '';

      // Gesamtmenge in der Basiseinheit (Stangen → Meter, Beutel → Stück). Nur der WERT, das
      // Label steht daneben — die „= 12 m"-Kurzform aus dem Warenkorb wäre hier redundant.
      var totalQty = '';
      if (isVe && window.SU) {
        var tb = window.SU.totalBase(ln.quantity, q, vpe.base);
        if (tb) totalQty = tb.value + ' ' + qtyUnitWord(vpe.label, vpe.base);
      }

      var facts = '';
      if (isVe) {
        facts += fact(CS.irUnit || 'Verpackungseinheit',
                      vpe.label ? escHtml(vpe.label) : (q + ' ' + unitLabelOf(vpe.base)));
        facts += fact(CS.irQty || 'Anzahl', ln.quantity + ' ' + (CS.irVeShort || 'VE'));
        if (totalQty) facts += fact(CS.irTotalQty || 'Gesamtmenge', totalQty, 'ir-fact--accent');
        facts += fact(CS.irPricePerVe || 'Preis je VE', formatPrice(packPrice));
        // Preis je Basiseinheit (pro Meter / pro Stück) — bis 2026-08-12 stand in der Übersicht
        // nur der Preis je Verkaufseinheit; der Kunde musste selbst durch die VE teilen.
        facts += fact(unitPriceLabel(vpe.label, vpe.base), 'CHF\u00a0' + unitPriceText(packPrice / q, q));
      } else {
        facts += fact(CS.irQty || 'Anzahl', ln.quantity + ' ' + unitLabelOf(vpe.base));
        facts += fact(CS.irPricePerPiece || 'Preis je Stück', formatPrice(packPrice));
      }
      // Anzahl der Kennzahlen steuert die Zeilenzahl des Rasters (s. component-invoice-review.css):
      // links VE / Anzahl / Gesamt, rechts Preis / VE und Preis je Basiseinheit.
      var factCount = isVe ? (totalQty ? 5 : 4) : 2;

      return '<li class="ir-line">'
        + '<div class="ir-line__head">'
          + '<div class="ir-thumb">'
            + (img ? '<img src="' + escHtml(img) + '" alt="" loading="lazy" width="64" height="64">' : '')
          + '</div>'
          + '<div class="ir-ident">'
            + '<p class="ir-name">' + escHtml(title) + '</p>'
            + (vt ? ('<span class="ir-variant">' + escHtml(vt) + '</span>') : '')
            + (ln.sku ? ('<span class="ir-sku">' + escHtml(ln.sku) + '</span>') : '')
          + '</div>'
          + '<dl class="ir-linetotal">'
            + '<dt>' + (CS.irLineTotal || 'Position gesamt') + '</dt>'
            + '<dd>' + moneyCell(formatPrice(lt)) + '</dd>'
          + '</dl>'
        + '</div>'
        + '<dl class="ir-facts ir-facts--' + factCount + '">' + facts + '</dl>'
        + '</li>';
    }).join('');

    var shipping  = preview.shipping;
    var shipPrice = shipping ? parseFloat(shipping.price) : 0;
    // ⚠️ Versandmodus kommt vom SERVER und darf NICHT aus dem Preis erraten werden:
    // „kostenlos" und „wird separat verrechnet" sind BEIDE 0.00. Fehlt das Feld (Flag aus),
    // bleibt shipMode null und die Darstellung ist unveraendert wie bisher.
    var shipMode = preview.shipping_mode || null;
    var shipMax  = parseFloat(preview.shipping_max);
    var shipDecision = shipMode ? { mode: shipMode, amount: shipPrice, maxShip: isFinite(shipMax) ? shipMax : 0 } : null;
    // Summen kommen vom SERVER (autoritativ, identisch zur erzeugten Draft Order).
    var _srvSub   = parseFloat(preview.subtotal);
    var _srvTotal = parseFloat(preview.total);
    if (isFinite(_srvSub)) subtotal = _srvSub;
    var total = isFinite(_srvTotal) ? _srvTotal : (subtotal + shipPrice);

    // Nicht bestellbare Positionen UND unvollständige Preise sichtbar machen.
    // prices_complete=false heisst: für eine Position fehlt sogar der Listenpreis-Fallback
    // (unit_price fällt serverseitig bereits auf variant.price zurück) — Ausnahmefall, der
    // nicht clientseitig weggerechnet werden darf.
    var _notes = [];
    if (preview.missing_skus && preview.missing_skus.length) {
      _notes.push(CS.lgMissingFull + escHtml(preview.missing_skus.join(', ')) + '.');
    }
    if (preview.prices_complete === false) {
      _notes.push(escHtml(CS.lgPricesIncomplete
        || 'Für einzelne Positionen konnte kein verbindlicher Preis ermittelt werden. Der Innendienst prüft die Bestellung vor der Verrechnung.'));
    }
    var missing = _notes.length ? '<p class="ir-note">' + _notes.join(' ') + '</p>' : '';

    // Währung und Zahl getrennt ausgeben, damit die „CHF" der Summenzeilen untereinander stehen
    // (die Zahl sitzt in einer Box fester Mindestbreite, rechtsbündig — s. .ir-money im CSS).
    function moneyCell(text) {
      var t = String(text);
      var i = t.search(/[\d]/);
      if (i <= 0) return '<span class="ir-money"><span class="ir-num">' + escHtml(t) + '</span></span>';
      return '<span class="ir-money"><span class="ir-cur">' + escHtml(t.slice(0, i).trim())
        + '</span><span class="ir-num">' + escHtml(t.slice(i)) + '</span></span>';
    }

    // ⚠️ Aufschluesselung nur zeigen, wenn sie etwas erklaert — identische Regel wie im
    // Gate-Panel (checkout-gate.js), sonst weichen die beiden Uebersichten voneinander ab.
    // Im Regelfall der Versandregel v2 wird dem B2B-Kunden kein Versand berechnet: dann sind
    // Zwischensumme und Gesamt gleich, und „Zwischensumme / Standardversand gratis / Gesamt"
    // sind drei Zeilen fuer eine Zahl. Sobald ein Betrag dazukommt, MUSS die Aufschluesselung
    // erscheinen — eine Summe ohne ihre Bestandteile waere irrefuehrend.
    var breakdown = Math.abs(total - subtotal) >= 0.005;

    var summary = '<table class="ir-summary"><tbody>'
      + (breakdown
        ? ('<tr><th scope="row">' + (CS.irSubtotal || 'Zwischensumme') + '</th><td>'
           + moneyCell(formatPrice(subtotal)) + '</td></tr>')
        : '')
      + (breakdown && shipping
        ? ('<tr><th scope="row">' + escHtml(shipRowLabel(shipTitle(shipping.title))) + '</th><td>'
           + moneyCell(
               shipDecision && window.SP
                 ? window.SP.label(shipDecision)
                 : (shipPrice > 0 ? formatPrice(shipPrice) : (CS.shipFree || 'gratis'))
             ) + '</td></tr>')
        : '')
      + '<tr class="ir-summary__total"><th scope="row">' + (CS.irGrandTotal || 'Gesamt (exkl. MwSt)') + '</th><td>' + moneyCell(formatPrice(total)) + '</td></tr>'
      + '</tbody></table>';
      // Die separate Versand-Hinweiszeile entfaellt (13.08.2026) — sie stand unmittelbar ueber
      // dem Disclaimer, der dasselbe Thema behandelt. Der Maximalbetrag steht jetzt IM
      // Disclaimer, s. window.SP.disclaimer() weiter unten.

    var overlay = document.createElement('div');
    overlay.id = 'b2b-invoice-review-overlay';
    overlay.className = 'ir-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'ir-title');
    overlay.innerHTML =
      '<div class="ir-panel">'
      + '<header class="ir-head">'
        + '<p class="ir-eyebrow">' + (CS.irInvoiceMode || 'Kauf auf Rechnung') + '</p>'
        + '<h2 class="ir-title" id="ir-title">' + (CS.lgOrderReview || 'Bestellübersicht') + '</h2>'
      + '</header>'
      + '<div class="ir-body">'
        + missing
        + '<p class="ir-lines-heading">' + (CS.irItems || 'Artikel') + '</p>'
        + '<ul class="ir-lines">' + rows + '</ul>'
        + summary
        // ⚠️ Text aus customStrings ist bereits HTML-escaped (Liquid-`t`-Filter) — kein
        // zweites escHtml(), sonst steht auf FR „l&#39;article" sichtbar in der Seite.
        + '<p class="ir-disclaimer">' + ((window.SP && window.SP.disclaimer)
            ? window.SP.disclaimer(shipDecision) : (CS.lgDisclaimer || '')) + '</p>'
      + '</div>'
      + '<footer class="ir-actions">'
        + '<button type="button" class="ir-btn ir-btn--primary" id="b2b-invoice-review-ok">' + (CS.lgBinding || '') + '</button>'
        + '<button type="button" class="ir-btn ir-btn--ghost" id="b2b-invoice-review-cancel">' + (CS.cancelJs || 'Abbrechen') + '</button>'
      + '</footer>'
      + '</div>';

    document.body.appendChild(overlay);
    alignMoney(overlay);
    // Web Fonts können nach dem ersten Messen noch eintreffen → einmal nachjustieren.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { alignMoney(overlay); });
    }

    var submitting = false;
    function close() {
      document.removeEventListener('keydown', onKey);
      overlay.remove();
    }
    function cancel() {
      close();
      setCheckoutBtns(false);
    }
    function onKey(e) {
      if (e.key === 'Escape' && !submitting) cancel();
    }
    document.addEventListener('keydown', onKey);
    // Klick auf den abgedunkelten Rand = abbrechen; Klicks im Panel dürfen nicht durchschlagen.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay && !submitting) cancel();
    });

    document.getElementById('b2b-invoice-review-ok').addEventListener('click', function () {
      if (submitting) return;
      submitting = true;
      close();
      onConfirm();
    });
    document.getElementById('b2b-invoice-review-cancel').addEventListener('click', cancel);
    document.getElementById('b2b-invoice-review-ok').focus();
  }

  // Best\u00e4tigungsziel nach erfolgreicher Rechnungsbestellung (keine Online-Zahlung).
  var INVOICE_DONE_URL = window.localizeUrl('/pages/konto') + '?bestellung=rechnung';

  // Letzte Bestelluebersicht + Titel je SKU — fuer das GA4-purchase-Event
  // (siehe assets/gtm-ecommerce.js). Gegenstueck in checkout-gate.js.
  var _lastPreview = null;
  var _lastTitles  = null;

  // Warenkorb leeren, danach immer weiterleiten (Leerung ist nicht fatal). Nur nach erfolgreicher
  // Rechnungsbestellung; der Online-Pfad leitet auf den Shopify-Checkout, der den Cart selbst leert.
  //
  // ⚠️⚠️ /cart/clear.js raeumt NUR die Positionen ab — `note` und `attributes` bleiben am
  // Server-Cart stehen. Ohne resetServer() wandern Notiz und PO-Nummer der gerade
  // abgeschickten Bestellung in die naechste (Aufgabe #42). B2BCartAttrs.reset() allein
  // genuegt NICHT: das leert nur den lokalen Modul-State und die Felder im DOM.
  //
  // ⚠️ Dieser Pfad ist das Gegenstueck zu cgClearCartThen() in checkout-gate.js: DORT die
  // localStorage-Auth, HIER die native Shopify-B2B-Session. Beide bestellen auf Rechnung,
  // beide brauchen dieselbe Leerung — eine Aenderung an einer Stelle gehoert immer an beide.
  //
  // Reihenfolge bewusst: erst update, dann clear. Bricht der Browser nach dem ersten Schritt
  // ab (Tab zu, Netz weg), ist die Notiz trotzdem weg und nur der volle Korb bleibt —
  // umgekehrt waere es genau der alte Fehler.
  function cgClearCartThen(url) {
    function go() { window.location.href = url; }
    // ⚠️ try/catch ist Absicht: wirft resetServer() SYNCHRON (fehlendes fetch, kaputtes
    // Modul), liefe go() nie — der Kunde haenge nach erfolgreicher Bestellung ohne
    // Bestaetigung fest. Die Leerung ist nie wichtiger als die Weiterleitung.
    var cleared;
    try {
      cleared = (window.B2BCartAttrs && window.B2BCartAttrs.resetServer)
        ? window.B2BCartAttrs.resetServer()
        : Promise.resolve(false);
    } catch (e) {
      cleared = Promise.resolve(false);
    }
    _cartNote = null;
    // Weiterleitung nie blockieren: 2s ist die Obergrenze, danach geht es weiter.
    // (Vorher wartete clear.js ohne jede Obergrenze.)
    Promise.race([cleared, new Promise(function (r) { setTimeout(r, 2000); })])
      .then(function () { return fetch('/cart/clear.js', { method: 'POST' }); })
      .then(go, go);
  }

  function proceedToCheckout(items, mode, noteAttributes) {
    var isInvoice = (mode === 'invoice');
    var endpoint  = isInvoice ? '/api/b2b/create-invoice-order' : '/api/b2b/create-draft-order';
    setCheckoutBtns(true, 'Bitte warten\u2026');
    var orderBody = { customer_email: EMAIL, items: items.map(function (i) { return { sku: i.sku, quantity: i.quantity }; }) };
    if (noteAttributes && noteAttributes.length) {
      orderBody.note_attributes = noteAttributes;
    }
    if (_cartNote) {
      orderBody.note = _cartNote;
    }
    fetch(API_BASE + endpoint, {
      method: 'POST',
      headers: orderHeaders(),
      body: JSON.stringify(orderBody)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (isInvoice) {
          if (res.ok && res.data.status === 'invoice_pending') {
            // GA4-Kauf ablegen; gemeldet wird er erst auf der Bestaetigungsseite.
            if (window.GTMEC) window.GTMEC.stashPurchase(_lastPreview, res.data, _lastTitles);
            cgClearCartThen(INVOICE_DONE_URL);
          } else {
            setCheckoutBtns(false);
            showCheckoutError(res.data.error || 'Die Bestellung auf Rechnung konnte nicht abgeschlossen werden. Bitte versuche es erneut.');
          }
          return;
        }
        if (res.data.checkout_url) {
          window.location.href = res.data.checkout_url;
        } else if (!res.ok) {
          setCheckoutBtns(false);
          showCheckoutError(res.data.error || 'B2B-Bestellung konnte nicht erstellt werden. Bitte versuche es erneut.');
        } else {
          setCheckoutBtns(false);
          alert('B2B-Bestellung konnte nicht erstellt werden. Bitte versuche es erneut.');
        }
      })
      .catch(function (e) {
        console.error('[B2B] Draft order error:', e);
        setCheckoutBtns(false);
        alert('Verbindungsfehler. Bitte erneut versuchen.');
      });
  }

  // Freie Warenkorb-Notiz des aktuellen Bestellvorgangs. Modul-Variable statt
  // zusaetzlichem Parameter: proceedToCheckout() wird an fuenf Stellen aufgerufen.
  var _cartNote = null;

  function b2bCheckout(mode) {
    // ⚠️ Erst die B2B-Bestellinformationen persistieren, dann den Warenkorb lesen —
    // sonst bestellt der Kunde ohne die gerade getippte PO-Nummer. Dieser Pfad ruft
    // cgPrefetchCart() nicht auf, braucht den Flush also selbst.
    var pre = (window.B2BCartAttrs && window.B2BCartAttrs.flush)
      ? window.B2BCartAttrs.flush().catch(function () { return false; })
      : Promise.resolve(true);

    pre
      .then(function () { return fetch('/cart.json'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || [])
          .filter(function (i) { return !!i.sku; })
          .map(function (i) { return { sku: i.sku, quantity: i.quantity, cartPriceCHF: i.price / 100 }; });

        if (!items.length) return;

        // Forward cart notes (PO-Nummer, Kommission, Kostenstelle, Lieferhinweis,
        // Bemerkung, …) so they reach the Abacus order comment.
        // dirty() ergaenzt nur lokal geaenderte, noch nicht bestaetigte Werte —
        // Rueckfalllinie, falls /cart/update.js scheiterte.
        _cartNote = (cart && cart.note) ? String(cart.note).slice(0, 500) : null;
        var attrs = Object.assign(
          {},
          cart.attributes || {},
          (window.B2BCartAttrs && window.B2BCartAttrs.dirty) ? window.B2BCartAttrs.dirty() : {}
        );
        var noteAttributes = [];
        for (var key in attrs) {
          if (Object.prototype.hasOwnProperty.call(attrs, key) && attrs[key] !== '' && attrs[key] != null) {
            noteAttributes.push({ name: key, value: String(attrs[key]) });
          }
        }

        setCheckoutBtns(true, window.customStrings.pricesChecking);

        // Kauf auf Rechnung: verbindliche Bestellübersicht (Review-Overlay) statt direkt bestellen.
        // Das Review zeigt die aktuellen, verbindlichen Preise und verlangt aktive Bestätigung →
        // ersetzt im Invoice-Modus den §12-Preisänderungs-Dialog. Online behält §12 unverändert.
        if (mode === 'invoice') {
          setCheckoutBtns(true, window.customStrings.reviewLoading);
          showInvoiceReviewOverlay(cart, items, noteAttributes);
          return;
        }

        // Leitbild §12: Fetch fresh prices and compare to what was shown in the cart
        fetchPrices(items.map(function (i) { return i.sku; }))
          .then(function (result) {
            var prices = result.prices;
            var meta   = result.meta;

            // Abacus unavailable: pass through — DraftOrderController handles 503 / fallback
            if (meta.abacus_available === false) {
              proceedToCheckout(items, mode, noteAttributes);
              return;
            }

            // §12: Vergleiche den frischen, verbindlichen B2B-Preis gegen den im Warenkorb ZUVOR
            // ANGEZEIGTEN B2B-Preis (aus dem Cache) — gleiche Einheit (netto/Basis). NICHT gegen den
            // Listenpreis (item.cartPriceCHF = Gast-Variantenpreis), sonst würde bei jeder Meterware/VPE
            // fälschlich eine „Preisänderung" gemeldet. Kein Vorwert bekannt → keine Änderung annehmen.
            var changed = [];
            items.forEach(function (item) {
              var ap = prices[item.sku];
              if (ap === null || ap === undefined) return;
              var prevEntry = (window.B2BPriceCache && window.B2BPriceCache.get)
                ? window.B2BPriceCache.get(item.sku)
                : null;
              var prev = (prevEntry && typeof prevEntry.price === 'number') ? prevEntry.price : null;
              if (prev !== null && Math.abs(ap - prev) > 0.01) {
                changed.push({ sku: item.sku, oldPrice: prev, newPrice: ap, quantity: item.quantity });
              }
            });

            if (changed.length > 0) {
              setCheckoutBtns(false);
              showPriceConfirmOverlay(changed, function () { proceedToCheckout(items, mode, noteAttributes); });
            } else {
              proceedToCheckout(items, mode, noteAttributes);
            }
          })
          .catch(function () {
            // Price fetch error: proceed anyway; DraftOrderController is authoritative
            proceedToCheckout(items, mode, noteAttributes);
          });
      })
      .catch(function (e) {
        console.error('[B2B] Cart fetch error:', e);
      });
  }

  // ── Event wiring ──────────────────────────────────────────────────────────

  // Intercept checkout clicks in capture phase (before theme JS)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#CartDrawer-Checkout, button[name="checkout"], [data-payment="invoice"]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var mode = (btn.getAttribute('data-payment') === 'invoice') ? 'invoice' : 'online';
    b2bCheckout(mode);
  }, true);

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    // Product page
    if (document.querySelector('.product-form, .product__info-wrapper')) {
      updateProductPagePrice();
      // Watch SKU element for variant changes
      var skuEl = document.querySelector('.product__sku');
      if (skuEl) {
        new MutationObserver(updateProductPagePrice).observe(skuEl, {
          childList: true, subtree: true, characterData: true
        });
      }
    }
    // Sticky-Bar-Variantenauswahl (Listenpreis im <option>-Text)
    updateStickySelectPrices();
    // Cart
    updateCartPrices();
  });

  // Anderen Modulen (checkout-gate.js) erlauben, den B2B-Total bei Bedarf frisch zu berechnen.
  window.B2BRefreshCart = updateCartPrices;
  // QA-Haken: die Bestellübersicht „Kauf auf Rechnung" lässt sich sonst nur mit echtem
  // B2B-Login und echtem Bestellklick sichtbar machen. Rendert nur (read-only) — bestellt wird
  // erst über den onConfirm-Callback, den der reguläre Pfad übergibt.
  window.B2BRenderInvoiceReview = renderInvoiceReviewOverlay;

  // Wird nur für eingeloggte B2B-Kunden gesetzt (dieser IIFE-Block läuft sonst gar nicht,
  // s. Guard oben). Andere Module (z. B. product-accessories.js) holen darüber die
  // Individualpreise für eine SKU-Liste und formatieren einheitlich (Tausender-Apostroph),
  // statt die Logik zu duplizieren. Fehlt der Helfer → Aufrufer nutzt Listenpreis-Fallback.
  window.B2BFetchPrices = fetchPrices;   // (skus[]) → Promise<{prices:{sku:CHF}, meta}>
  window.B2BFormatPrice = formatPrice;   // (chf) → "CHF 1'234.00"

  // Re-run after Shopify section re-renders (e.g. cart drawer opens)
  document.addEventListener('shopify:section:load', function () {
    updateCartPrices();
    updateProductPagePrice();
  });

  // Custom cart:refresh event some themes fire
  document.addEventListener('cart:refresh', updateCartPrices);

  // Cart-Drawer & Warenkorbseite rendern ihre Items bei jeder Mutation per
  // innerHTML NEU (PUB_SUB_EVENTS.cartUpdate) → die B2B-Preise würden auf
  // Listenpreise zurückfallen. Nach dem Re-Render erneut anwenden.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(updateCartPrices, 0); });
  }

  // ── Bestätigung nach Bestellung auf Rechnung ──────────────────────────────
  // Native B2B-Sessions landen nach erfolgreicher Rechnungsbestellung auf
  // /pages/konto?bestellung=rechnung. Identischer Block in checkout-gate.js
  // (localStorage-Auth); Dedup-Guard verhindert Doppelung.
  (function invoiceOrderConfirmation() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('bestellung') !== 'rechnung') return;
      if (document.getElementById('b2b-invoice-confirm')) return;

      function render() {
        if (document.getElementById('b2b-invoice-confirm')) return;
        var host = document.getElementById('MainContent') || document.body;
        var box = document.createElement('div');
        box.id = 'b2b-invoice-confirm';
        box.className = 'b2b-invoice-confirm';
        box.setAttribute('role', 'status');
        box.innerHTML =
          '<button type="button" class="b2b-invoice-confirm__close" aria-label="' + window.customStrings.closeAria + '">×</button>' +
          '<strong>' + window.customStrings.lgInvoiceReceived + '</strong>' +
          '<span>' + window.customStrings.lgInvoiceEmail + window.customStrings.lgInvoiceStatus + '</span>';
        host.insertBefore(box, host.firstChild);
        var closeBtn = box.querySelector('.b2b-invoice-confirm__close');
        if (closeBtn) closeBtn.addEventListener('click', function () {
          if (box.parentNode) box.parentNode.removeChild(box);
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', render);
      } else {
        render();
      }

      params.delete('bestellung');
      var qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) {}
  })();

})();
